const API_BASE_URL = import.meta.env.VITE_SERVER_HOST || "";

export const apiFetch = (endpoint: string, options: RequestInit) => {
  const url = `${API_BASE_URL}${endpoint}`;
  return fetch(url, options);
};
